export default class {

    /**
     * constructor
     */
    constructor(){
        this.data = {};
        this.setEvent();
    }

    /**
     * setEvent
     */
    setEvent(){
        document.addEventListener('mousemove', (e) => {
            this.data = this.update(e.clientX, e.clientY);
        });
    }

    /**
     * get
     */
    get(){
        return this.data;
    }

    /**
     * update
     */
    update(clientX, clientY){
        let centerX = window.innerWidth / 2;
        let centerY = window.innerHeight / 2;
        return {
            x: (clientX - centerX) / centerX,
            y: (clientY - centerY) / centerY
        };
    }

}